import React from 'react'
import SignupForm from "../whitaijiFrontendLibrary/auth/components/SignupForm"
import { AuthContext } from "../context/AuthContext"

const Signup = () => {


  return (
    <div>
      <SignupForm AuthContext={AuthContext}/>
    </div>

  )
}

export default Signup